<template>
    <div>
        <DxTabPanel>
            <DxItem :title="$t('signal_viewer.modals.settings_modal.tabs_panel.visualization.title')">
                <template #default>
                    <label class="d-block">
                        {{ $t('signal_viewer.modals.settings_modal.tabs_panel.visualization.analog_tab.title') }}
                    </label>
                    <DxCheckBox
                        :text="$t('signal_viewer.modals.settings_modal.tabs_panel.visualization.dx_check_boxes.select_all')"
                        @valueChanged="selectAllAnalogSignals"></DxCheckBox>
                    <div v-for="analogSignal in analogSignalDataSource" :key="analogSignal.index">
                        <DxCheckBox v-model:value="result.analogSignalsVisibility[analogSignal.index]"
                            :text="analogSignal.name"></DxCheckBox>
                    </div>
                    <label class="d-block mt-3">
                        {{ $t('signal_viewer.modals.settings_modal.tabs_panel.visualization.discrete_tab.title') }}
                    </label>
                    <DxCheckBox
                        :text="$t('signal_viewer.modals.settings_modal.tabs_panel.visualization.dx_check_boxes.select_all')"
                        @valueChanged="selectAllDiscreteSignals"></DxCheckBox>
                    <div v-for="discreteSignal in discreteSignalDataSource" :key="discreteSignal.index">
                        <DxCheckBox v-model:value="result.discreteSignalsVisibility[discreteSignal.index]"
                            :text="discreteSignal.name"></DxCheckBox>
                    </div>
                </template>
            </DxItem>
        </DxTabPanel>
    </div>
</template>

<script setup lang="ts">
import { useIntl } from '@/.shared/services/i18n';
import { DxItem } from "devextreme-vue/tab-panel";
import Osc, { type SettingsDialogResult } from "./osc";
import { DxCheckBox, DxTabPanel } from "devextreme-vue";
import type { ValueChangedEvent } from "devextreme/ui/check_box";
import { useModalBuilder } from "@/.shared/helpers/modal-building-helper";
import { computed, getCurrentInstance, onMounted, reactive, ref } from "vue";
import { cancelButtonProps, saveButtonProps } from "@/.shared/helpers/button-helper";

const i18n = useIntl();
const modal = useModalBuilder();
const props = defineProps<{}>();
const data = ref(Osc.getOscData());

const result = reactive(buildInitialState());
const analogSignalDataSource = computed(() => {
    const signals: { name: string, index: number }[] = (data.value["analog_signals"] as any).map((s: any, idx: number) => ({ name: s.name as string, index: idx }));
    return signals;
})

const discreteSignalDataSource = computed(() => {
    const signals: { name: string, index: number }[] = (data.value["discrete_signals"] as any).map((s: any, idx: number) => ({ name: s.name as string, index: idx }));
    return signals;
})

onMounted(() => {
    modal.setContext(getCurrentInstance()!);
    const saveButton = modal.addButton("save",
        {
            ...saveButtonProps()
            , onClick: () => {
                result.result = "ok";
                modal.close(result);
            }
        }, { toolbar: "bottom", location: "after" });
    const cancelButton = modal.addButton("cancel", { ...cancelButtonProps(), onClick: () => modal.close(result) }, { toolbar: "bottom", location: "after" });
});

function selectAllAnalogSignals(e: ValueChangedEvent) {
    result.analogSignalsVisibility = result.analogSignalsVisibility.map(() => e.value);
}

function selectAllDiscreteSignals(e: ValueChangedEvent) {
    result.discreteSignalsVisibility = result.discreteSignalsVisibility.map(() => e.value);
}

function buildInitialState(): SettingsDialogResult {
    return {
        result: "cancel",
        analogSignalsVisibility: data.value["analog_signals"].map((x: any) => x.isVisible),
        discreteSignalsVisibility: data.value["discrete_signals"].map((x: any) => x.isVisible)
    }
}
</script>
